import { Link } from 'react-router-dom';
import { ProductImage } from '../../ui/ProductImage';
import { shopLabels } from '../../data/shopLabels';
import type { Product } from '../../core/types/catalog';
import { euro } from '../../core/format/currency';
import { isSoldOut } from '../../core/rules/stock';
import { AddButton } from '../shared/AddButton';
type Props = {
  products: Product[];
  /** `compact` in het journaloverzicht, `sidebar` naast een artikel (met merk boven de naam). */
  variant?: 'compact' | 'sidebar';
};

/** "Genoemd in dit artikel": productnaam naar de shop, plusje naar de winkelmand (met vinkje als bevestiging). */
export function MentionedProducts({
  products,
  variant = 'compact'
}: Props) {
  const sidebar = variant === 'sidebar';
  return <ul className="mt-3 divide-y divide-line border-y border-line" data-id="element-7678" data-mp="36m207nl28xbr">
      {products.map(p => <li key={p.id} className={`flex items-center gap-3 ${sidebar ? 'py-3.5' : 'py-3'}`} data-id="element-7679" data-mp="zw3uaww0o1q7">
          {/* Decoratief: de productnaam ernaast is de link. */}
          <ProductImage src={p.image} alt="" className={`shrink-0 bg-blush ${sidebar ? 'h-16 w-14 p-1.5' : 'h-14 w-12 p-1'}`} data-id="element-7680" data-mp="1zlyhca6zuvaa" />
          <div className="min-w-0 flex-1" data-id="element-7681" data-mp="1vkn0at26ridp">
            {sidebar && <p className="text-[13px] text-clay" data-id="element-7682" data-mp="29c9tul4qucss">{p.brand}</p>}
            <Link to={`/webshop/${p.id}`} className="block text-[15px] leading-snug text-ink transition-colors duration-150 ease-soft hover:text-clay" data-id="element-7683" data-mp="29enpav3c5r0v">
              {p.name}
            </Link>
            <p className="mt-0.5 text-[14px] tabular-nums text-muted" data-id="element-7684" data-mp="1go5oy1tzy3r5">
              {sidebar ? euro(p.price) : `${p.brand} · ${euro(p.price)}`}
              {isSoldOut(p) && <span className="text-clay" data-id="element-7685" data-mp="1qn39yus7rf5e"> · {shopLabels.soldOutShort}</span>}
            </p>
          </div>
          <AddButton product={p} data-id="element-7686" data-mp="1lm77mlnig123" />
        </li>)}
    </ul>;
}